// src/components/homes/HomeDefault.js
import { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux'; // Importe useSelector
import { debug } from '../../utils'
import UserSignInModal from '../user/UserSignInModal';
import Modal from 'react-bootstrap/Modal';
import { FaBeer } from 'react-icons/fa';
import API from '../../api'
import './home-default.css';
const HomeDefault = () => {
  const user = useSelector((state) => state.user);
  const config = useSelector((state) => state.config);
  const bg = config?.tenant?.front?.home_default_background;
  const [showModal, setShowModal] = useState(false);
  const options = {
  }
  const onTabSwitch = () => { }
  useEffect(() => {
  }, [user])
  return (
    <>

      {!user.isSignedIn &&
        <div id="homepage-default" className=' py-5'>
          <article className="">
            <div
              className="background"
              style={bg ? { backgroundImage: `url(${bg})` } : undefined}
            />
            <div className="article-inner">
              <h1>
                {config?.tenant?.front?.home_default_message}
              </h1>
              <div className="text-center pt-5">
                <button className="btn btn-brand-primary btn-lg" onClick={e => setShowModal(true)}>CONNEXION</button>
                <UserSignInModal options={options} show={showModal} />
              </div>
            </div>
          </article >
        </div >
      }

      {
        user.isSignedIn &&
        <Navigate to='/home' replace />
      }
    </>
  )
};
export default HomeDefault;
